// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__a1XQW","container":"layout_container__M0Xrv","main":"layout_main__v2Oy8"};